import { FC } from "react";
import { useTrans } from "../../../hooks";
import { HStack, Text } from "@chakra-ui/react";
import {
    DataType,
    IKaTableProps,
    ITableInstance,
    Table as KaTable,
    SortingMode,
} from "ka-table";
import { Column, PagingOptions } from "ka-table/models";
import { ICellTextProps } from "ka-table/props";
import {
    AppOptionBoxItem,
    AppOptionsBox,
    KaPageSizeSelector,
} from "../../../components";
import { APPC, UTIL } from "../../../config";

export const CoordinatorRequestList: FC<{
    table: ITableInstance;
    paging: PagingOptions;
    list: any[];
    loadingList?: boolean;
    onActionClick?: (key: string, data?: any) => void;
}> = ({
    table,
    paging,
    list,
    loadingList = false,
    onActionClick = () => {},
}) => {
    const { t } = useTrans();
    const dayjs = UTIL.getDayJs();

    const columns: Column[] = [
        {
            key: "createdAt",
            title: t("ent.CoordinatorRequest:createdAt.label"),
            dataType: DataType.String,
        },
        {
            key: "email",
            title: t("ent.CoordinatorRequest:email.label"),
            dataType: DataType.String,
        },
        {
            key: "phone",
            title: t("ent.CoordinatorRequest:phone.label"),
            dataType: DataType.String,
            isSortable: false,
        },
        {
            key: "school.name",
            title: t("ent.CoordinatorRequest:schoolName.label"),
            dataType: DataType.Object,
            isSortable: false,
        },
        {
            key: "company.name",
            title: t("ent.CoordinatorRequest:companyName.label"),
            dataType: DataType.Object,
            isSortable: false,
        },
        {
            key: "action",
            title: "",
            style: { textAlign: "right" },
            dataType: DataType.Object,
            width: 50,
            isSortable: false,
        },
    ];

    const actionOptions: AppOptionBoxItem[] = [
        {
            key: "create",
            label: t(
                "padm.CoordinatorRequestPage:text.option.createCoordinator"
            ),
            iconName: "icl-user-plus",
        },
        {
            key: "delete",
            label: t("cmn:option.delete"),
            iconName: "icl-trash",
        },
    ];

    const kaTableProps: IKaTableProps = {
        table: table,
        columns: columns,
        data: list || [],
        loading: {
            enabled: loadingList,
        },
        paging: paging,
        rowKeyField: "id",
        sortingMode: SortingMode.SingleRemote,
        childComponents: {
            pagingSizes: {
                content: (props) => <KaPageSizeSelector {...props} />,
            },
            cellText: {
                content: (props: ICellTextProps) => {
                    switch (props?.column?.key) {
                        case "createdAt":
                            return (
                                <Text>
                                    {`${dayjs(props?.rowData?.createdAt).format(
                                        APPC.APP_DATEANDTIME_FORMAT
                                    )}`}
                                </Text>
                            );
                        case "firstName":
                            return (
                                <Text
                                    textStyle={"mediumSm"}
                                    color={"var(--chakra-colors-black)"}
                                >
                                    {`${props?.rowData?.firstName} ${props?.rowData?.lastName}`}
                                </Text>
                            );
                        case "action":
                            return (
                                <HStack justify={"flex-end"} gap={3}>
                                    <AppOptionsBox
                                        options={actionOptions}
                                        data={props?.rowData}
                                        onClick={onActionClick}
                                    />
                                </HStack>
                            );
                    }
                },
            },
        },
    };

    return <KaTable {...kaTableProps} />;
};
